module.exports = {"id":"107713","name":"Tom Starke","rating":"72","photo":"./data/images/photos/1/107713.png","club":{"name":"FC Bayern","logo":"./data/images/clubs/FCBayern.png"},"positions":["G"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/TomStarke0.json
// module id = 4172
// module chunks = 0